'use client'
import { FlowbiteCarouselTheme, Carousel } from 'flowbite-react'
import { formatDate } from '@/lib/postFunctions'
import InfamousQuoteCard from './infamousQuoteCard'
import { QuoteContent } from './quoteProps'

const customTheme: FlowbiteCarouselTheme = {
  root: {
    base: 'relative h-full w-full',
    leftControl:
      'font-bold absolute left-0 top-0 flex h-full items-center justify-center focus:outline-none',
    rightControl:
      'font-bold absolute right-0 top-0 flex h-full items-center justify-center focus:outline-none',
  },
  indicators: {
    active: {
      off: 'bg-white/50 hover:bg-white',
      on: 'bg-white dark:bg-gray-800',
    },
    base: 'h-3 w-3 rounded-full',
    wrapper: 'absolute bottom-5 left-1/2 flex -translate-x-1/2 space-x-3',
  },
  item: {
    base: 'absolute left-1/2 top-1/2 block w-full -translate-x-1/2 -translate-y-1/2 py-4 px-8 sm:px-12',
    wrapper: {
      off: 'w-full flex-shrink-0 transform cursor-default snap-center',
      on: 'w-full flex-shrink-0 transform cursor-grab snap-center',
    },
  },
  control: {
    base: 'inline-flex items-center justify-center rounded-full group-focus:outline-none sm:h-10 sm:w-10',
    icon: 'text-black h-6 w-6 font-extrabold !stroke-[3px]',
  },
  scrollContainer: {
    base: 'flex h-full snap-mandatory overflow-y-hidden overflow-x-auto scroll-smooth rounded-lg',
    snap: 'snap-x',
  },
}

interface IProps {
  quotes?: QuoteContent[]
}

export const InfamousQuotesComponent = ({ quotes }: IProps) => {
  return (
    <div className="pb-10">
      <div className="mt-flex flex-shrink-0 h-[200px] md:h-[260px] bg-gray-50 border border-gray-200 rounded-xl shadow-cards mt-[35px]">
        <div id="carousel-box" className="hidden h-full w-full">
          <Carousel theme={customTheme} indicators={false} slide={false}>
            {quotes &&
              quotes.map((quote, index) => (
                <div key={index} className="flex flex-col content-center h-full">
                  {quote && quote.quote && quote.reference && quote.Date && quote.name && (
                    <InfamousQuoteCard
                      quote={quote.quote}
                      reference={quote.reference}
                      Date={formatDate(quote.Date)}
                      name={quote.name}
                      index={index}
                      image={quote.image}
                    />
                  )}
                </div>
              ))}
          </Carousel>
        </div>
      </div>
    </div>
  )
}

export default InfamousQuotesComponent
